import React, { useCallback, useContext, useEffect } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const SuccessRegistered = ({
  setScreenNumber,
  telegramLink,
  handleBackToMenu,
  onTelegramHandleClick,
  isPartner = false
}) => {
  const { sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    sendEvent('passed_registration');
  }, []);

  const onTelegramClick = useCallback(() => {
    onTelegramHandleClick();
    window.open(telegramLink, '_blank');
  }, [telegramLink]);

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <p className={styles.title}>Дякуємо,</p>
      <p className={styles.description}>що приділив час на опитування!</p>
      {!isPartner && (
        <p className={styles.coloredDescription}>
          Твій рахунок буде поповнено найближчим часом.
        </p>
      )}
      <p className={styles.description}>
        Долучайся у Телеграм "Mr. Philip", щоб бути на зв'язку зі своїм брендом.
      </p>
      <img
        src={getImageFromS3('images/ua-hostess/result-sms-notifications.png')}
        alt="result-image"
      />
      <button onClick={onTelegramClick}>Доєднатися</button>
      {handleBackToMenu && (
        <button onClick={handleBackToMenu} style={{ marginTop: 10 }}>
          Повернутись до меню
        </button>
      )}
    </div>
  );
};

export default SuccessRegistered;
